<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Recurring Invoice Form
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</b-button>
          <b-button variant="danger mr-1" @click="close()"> <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>

      <b-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Template Invoice</label></b-input-group-prepend>
            <b-form-input readonly v-model="model.invoiceno" placeholder="Select AR Invoice as Template"></b-form-input>
            <b-input-group-append>
              <b-button variant="primary" @click="lkuArinvShow = true">
                <i class="fa fa-search"></i>
              </b-button>
            </b-input-group-append>

                <b-input-group-prepend><span class="p-2">Inv.Date</span></b-input-group-prepend>
                <b-form-input type="date" v-model="model.invdate" disabled></b-form-input>

          </b-input-group>

          <b-input-group v-if="model.CustName">
            <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
            <b-form-input readonly v-model="model.CustCode" ></b-form-input>
            <b-form-input readonly v-model="model.CustName" style="width: 50% !important"></b-form-input>
          </b-input-group>

          <b-form-row>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend><label>Frequency</label></b-input-group-prepend>
                <b-form-input type="number" v-model="model.frequency" min="1"></b-form-input>
                <b-input-group-prepend><span class="p-2">Unit</span></b-input-group-prepend>
                <b-form-select v-model="model.frequency_unit" :options="frequencyUnits"></b-form-select>
              </b-input-group>
            </b-col>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend><label class="text-right">Status</label></b-input-group-prepend>
                <b-form-checkbox v-model="model.is_active" :value="1" :unchecked-value="0" switch class="mt-2">
                  {{ model.is_active ? 'Active' : 'Inactive' }}
                </b-form-checkbox>
              </b-input-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label>Start Date</label></b-input-group-prepend>
                <b-form-input type="date" v-model="model.start_date"disabled></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><span class="p-2">End Date</span></b-input-group-prepend>
                <b-form-input type="date" v-model="model.end_date"></b-form-input>
              </b-input-group>
            </b-col>
          </b-form-row>


        </b-col>

        <b-col lg="6">
          <b-form-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><label>Service Start</label></b-input-group-prepend>
                <b-form-input type="date" v-model="model.service_start"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend><span class="p-2">Service End</span></b-input-group-prepend>
                <b-form-input type="date" v-model="model.service_end"></b-form-input>
              </b-input-group>
            </b-col>
          </b-form-row>
          <b-input-group>
            <b-input-group-prepend><label>Invoice Description</label></b-input-group-prepend>
            <b-form-input v-model="model.description" placeholder="Recurring Invoice Description template (EJS supported)"></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend><label>Service Periode (EJS)</label></b-input-group-prepend>
            <b-form-input v-model="model.service_periode_ejs" placeholder="Recurring Invoice Periode template (EJS supported)"></b-form-input>
          </b-input-group>


          <div class="alert alert-info py-2 mt-2" style="font-size: 0.85rem;">
            <i class="fa fa-info-circle"></i> <b>EJS Template Simulation (Example):</b>
            <div class="row mt-1">
              <div class="col-6"><code>&lt;%= serviceStart %&gt;</code> = {{model.service_start | moment("DD MMM YYYY") }}</div>
              <div class="col-6"><code>&lt;%= serviceStartMonth %&gt;</code> = {{model.service_start | moment("MMMM") }}</div>
              <div class="col-6"><code>&lt;%= serviceStartYear %&gt;</code> = {{model.service_start | moment("YYYY") }}</div>
              <div class="col-6"><code>&lt;%= serviceEnd %&gt;</code> = {{model.service_end | moment("DD MMM YYYY") }}</div>
              <div class="col-6"><code>&lt;%= serviceEndMonth %&gt;</code> = {{model.service_end | moment("MMMM") }}</div>
              <div class="col-6"><code>&lt;%= serviceEndYear %&gt;</code> = {{model.service_end | moment("YYYY") }}</div>
              <div class="col-6"><code>&lt;%= invoiceDate %&gt;</code> = {{model.start_date | moment("DD MMM YYYY") }}</div>
              <div class="col-6"><code>&lt;%= invoiceMonth %&gt;</code> = {{model.start_date | moment("MMMM") }}</div>
              <div class="col-6"><code>&lt;%= invoiceYear %&gt;</code> = {{model.start_date | moment("YYYY") }}</div>
            </div>
          </div>

        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col lg="12">
          <h5>Invoice Lines Template</h5>
          <b-table small striped hover :items="model.lines" :fields="lineFields">
            <template #cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <template v-slot:cell(description)="data">
              <pre class="mb-0" style="white-space: pre-wrap; font-size: smaller;">{{data.item.description}}</pre>
            </template>
            <template #cell(description_ejs)="data">
              <b-form-textarea
                v-model="data.item.description_ejs"
                rows="12"
                style="resize: vertical; min-height: 400px; font-size: smaller;"
                placeholder="Line description template (EJS supported)"
              ></b-form-textarea>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-card>

    <b-modal v-model="lkuArinvShow" size="lg" hide-footer title="Select AR Invoice Template">
      <lku-arinv @click="onSelectArinv"></lku-arinv>
    </b-modal>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>

<style scoped>
.input-group {
  margin-bottom: 10px;
}
.input-group-prepend label {
  width: 130px;
  padding-top: 7px;
}
::v-deep .table td {
  height: 100%;
}
::v-deep .table td textarea {
  resize: vertical !important;
}
</style>

<script>
import Loading from "vue-loading-overlay";
import moment from "moment";
import lkuArinv from "../lookup/lkuArinvLazzy";
import dropdown from "../../data/dropdown";
import api from "../../apis/recurringinvoice";
import arinvApi from "../../apis/arinv";

export default {
  components: { Loading, lkuArinv },
  data() {
    return {
      isLoading: false,
      lkuArinvShow: false,
      monthLabels: dropdown.monthLabels,
      frequencyUnits: [
        { value: "days", text: "Day(s)" },
        { value: "weeks", text: "Week(s)" },
        { value: "months", text: "Month(s)" },
        { value: "years", text: "Year(s)" }
      ],
      lineFields: [
        { key: 'lineno', label: 'No.', thStyle: "width:40px" },
        { key: "description", label: "Description", thStyle: "max-width:500px" },
        { key: "description_ejs", label: "Description EJS Template", thStyle: "min-width:400px", tdClass: "h-100 align-top" }
      ],
      model: {
        recinvkey: "",
        arinvkey: "",
        invoiceno: "",
        CustName: "",
        description: "",
        service_periode_ejs: "periode <%= startMonth %> <%= startYear %>",
        frequency: 1,
        frequency_unit: "months",
        start_date: moment().format("YYYY-MM-DD"),
        service_start: moment().startOf('month').format("YYYY-MM-DD"),
        service_end: moment().endOf('month').format("YYYY-MM-DD"),
        end_date: "",
        is_active: 1,
        lines: []
      }
    };
  },
  mounted() {
    const { id } = this.$route.query;
    if (id) {
      this.isLoading = true;
      api.detail(id).then(res => {
        this.model = res;
        this.model.invdate= moment(res.invdate).format('YYYY-MM-DD');
        this.model.start_date= moment(res.start_date).format('YYYY-MM-DD');
        this.model.service_start= moment(res.service_start).format('YYYY-MM-DD');
        this.model.service_end= moment(res.service_end).format('YYYY-MM-DD');
        this.model.end_date= moment(res.end_date).format('YYYY-MM-DD');
        // this.model.next_generation_date= moment(res.next_generation_date).format('YYYY-MM-DD');

        this.isLoading = false;
      }).catch(err => {
        this.isLoading = false;
        this.$bvToast.toast(err.message || 'Error loading detail', { variant: 'danger' });
      });
    }
  },
  methods: {
    onSelectArinv(data) {
      const item = data.selected;
      this.lkuArinvShow = false;
      
      // Use setTimeout to avoid focus trap conflict between modal and loading overlay
      setTimeout(() => {
        this.isLoading = true;
        this.model.arinvkey = item.arinvKey;
        this.model.invoiceno = item.invoiceno;
        this.model.CustName = item.CustName;
        this.model.CustCode = item.CustCode;
        this.model.description = item.uraian1 || "";
        this.model.ttlgross= item.ttlgross;
        this.model.ttldiskon= item.ttldiskon;
        this.model.ttlnetto= item.ttlnetto;
        this.model.ttlvat= item.ttlvat;
        this.model.ttlamtdue= item.ttlamtdue;
        this.model.invdate= moment(item.invdate).format('YYYY-MM-DD');
        this.model.start_date= moment(item.invdate).format('YYYY-MM-DD');
        
        arinvApi.detail({ arinvKey: item.arinvKey }).then(res => {
          const lines = res[1] || [];
          this.model.lines = lines.map(l => ({
            recinvdtkey: "",
            arinvdtKey: l.arinvdtKey,
            description: l.description || "",
            description_ejs:'',
            arinvKey: l.arinvKey,
            lineno: l.lineno || 0,
            salesKode: l.salesKode || '',
            linetype: l.linetype || 0,
            itemno: l.itemno || '',
            itemname: l.itemname || '',
            description: l.description || '',
            unitsize: l.unitsize || '',
            quantity: l.quantity || 0,
            unitprice: l.unitprice || 0,
            nilai: l.nilai || 0,
            disc: l.disc || 0,
            nilaidisc: l.nilaidisc || 0,
            nilainett: l.nilainett || 0,
            dpp: l.dpp || 0,
            kenappn: l.kenappn || 0,
            ppn: l.ppn || 0,
            nilaippn: l.nilaippn || 0,
            nilaidue: l.nilaidue || 0,
            kenapph: l.kenapph || 0,
            pasalpph: l.pasalpph || '',
            pph: l.pph || 0,
            nilaipph: l.nilaipph || 0,
            dppnlain: l.dppnlain || 100,
            priceinclvat: l.priceinclvat || 0,
            DimTableKey: l.DimTableKey || '',
            salesDtlKey: l.salesDtlKey || '',
            nettSales: l.nilainett || 0,
            printhide: l.printhide || 0,

          }));
          this.isLoading = false;
        }).catch(err => {
          this.isLoading = false;
          this.$bvToast.toast(err.message || 'Error fetching invoice lines', { variant: 'danger' });
        });
      }, 300);
    },
    save() {
      this.isLoading = true;
      api.save(this.model).then(() => {
        this.isLoading = false;
        this.$router.push({ name: "receivable.arinvrecurring" });
      }).catch(err => {
        this.isLoading = false;
        this.$bvToast.toast(err.message || 'Error saving data', { variant: 'danger' });
      });
    },
    close() {
      this.$router.push({ name: "receivable.arinvrecurring" });
    }
  }
};
</script>
